<template>
<div>
    <div v-if="timelineReady" class="timeline-wrapper">
        <ul class="nav tab-filter-menu timeline">
            <li v-for="(item, index) in filterOption" :key="index" :data-test="value" class="state" :class="[item.id < lastTimelineWithCandidate ? 'done' : item.id == lastTimelineWithCandidate ? 'current': '' ]">

                <a v-if="item.site"
                   :href="'?id='+item.site+'&job='+item.job"
                   class="nav-link py-0"
                   :class="[currentSiteId == item.site || currentSiteTimelineState == item.id ? 'active' : index === 0 && lastTimelineWithCandidate === '' ? 'done': '']">
                    <div v-if="timelineStates.length > 0 && timelineCandidates.length > 0">
                        {{ getTimelineStateName(item.id) }}
                    </div>
                    <div v-else>
                        {{ item.value }}
                    </div>

                    <div class="badge">
                        <div v-if="index == filterOption.length - 1">
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort"></i>
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort hidden"></i>
                        </div>

                        <span v-if="timelineCandidates[item.id]">{{ timelineCandidates[item.id] }}</span>
                        <span v-else>0</span>
                    </div>
                </a>
                <a v-else
                   :href="'?timeline='+item.id"
                   class="nav-link py-0"
                   :class="[value == item.id ? 'active' : index === 0 && lastTimelineWithCandidate === '' ? 'done': '']"
                   @click.prevent="getFilterValue(item.id); setPushState(item.id)">
                    <div v-if="timelineStates">{{ getTimelineStateName(item.id) }}</div>
                    <div v-else>
                        {{ item.value }}
                    </div>

                    <div class="badge">
                        <div v-if="index == filterOption.length - 1">
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort"></i>
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort hidden"></i>
                        </div>

                        <span v-if="timelineCandidates[item.id]">{{ timelineCandidates[item.id] }}</span>
                        <span v-else>0</span>
                    </div>
                </a>
                <div class="line line-left"></div>
                <div class="line line-right"></div>

            </li>


            <!-- @todo: Klik otevre modal -->
            <button class="btn btn-filter settings-timeline-button" type="button" @click.prevent="openAlertModal()" style="display:none;">
                <app-icon :name="'settings'" width="20" height="20"/>
            </button>


            <app-alert-modal
                v-if="alertModalActive"
                :table-id="tableId"
                modal-id="alert-modal"
                modal-size="large"
                modal-alignment="top"
                @close-modal="closeAlertModal"
            />
        </ul>
    </div>
    <div v-else>
        <ul class="nav tab-filter-menu timeline">
            <li v-for="(item, index) in filterOption" :key="index" class="state" :class="[item.id < value ? 'done' : value == item.id ? 'current': '' ]">
                <a href=""
                   class="nav-link py-0"
                   :class="[value == item.id ? 'active' : index === 0 && value === '' ? 'done': '']"
                   @click.prevent="getFilterValue(item.id)">


                    <div>
                    {{ item.value }}
                    </div>


                    <div class="badge">
                        <div v-if="index == filterOption.length - 1">
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort"></i>
                            <i class="custom-icon custom-icon-triangle-right custom-icon-sort hidden"></i>
                        </div>

                        <span>0</span>
                    </div>
                </a>
                <div class="line line-left"></div>
                <div class="line line-right"></div>

            </li>


            <!-- @todo: Klik otevre modal -->
            <button class="btn btn-filter settings-timeline-button" type="button" @click.prevent="openAlertModal()">
                <app-icon :name="'settings'" width="20" height="20"/>
            </button>


            <app-alert-modal
                v-if="alertModalActive"
                :table-id="tableId"
                modal-id="alert-modal"
                modal-size="large"
                modal-alignment="top"
                @close-modal="closeAlertModal"
            />
        </ul>
    </div>
</div>

</template>

<script>
    import CoreLibrary from "../../helpers/CoreLibrary";

    export default {
        name: "TimelineFilter",
        extends: CoreLibrary,
        props: {
            filterOption: {
                type: Array,
                required: true,
            },
            filterKey: {
                type: String
            },
            timelineCandidates: {
                type: Object
            },
            timelineStates: {
                type: Array
            },
            active: {}
        },
        data() {
            return {
                value: '',
                alertModalActive: false,
                timelineReady: false,
                currentSiteId: 0,
                currentSiteTimelineState: 0,
                lastTimelineWithCandidate: 0,
            }
        },
        watch: {
          timelineCandidates: {
            immediate: true,
            handler (val, oldVal) {
                if(oldVal){
                    this.timelineReady = true;
                    this.lastTimelineWithCandidate = Number(Object.keys(val)[Object.keys(val).length - 1]);
                }

            }
          },
          active: {
            immediate: true,
            handler (val, oldVal) {
                this.value = val;
            }
          }
        },
        created() {
            // If URL changed (without reload) and timeline_state was set, set timeline_state active
            window.onpopstate = () => {
                if (history.pushState && location.href.indexOf("?timeline") != -1) {
                    let currentTimelineId = parseInt(this.getUrlParameter('timeline', location.href));
                    this.getFilterValue(currentTimelineId);
                } else if (history.pushState){
                    this.getFilterValue(this.filterOption[0].id);
                }
            };

            this.getSiteId();
        },
        mounted() {
            // If reload happened, set timeline_state active
            if (history.pushState && location.href.indexOf("?timeline") != -1) {
                let currentTimelineId = parseInt(this.getUrlParameter('timeline', location.href));
                this.getFilterValue(currentTimelineId);
            }
        },
        methods: {
            getUrlParameter(name, url) {
                if (!url) url = location.href;
                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                var regexS = "[\\?&]"+name+"=([^&#]*)";
                var regex = new RegExp( regexS );
                var results = regex.exec( url );
                return results == null ? null : results[1];
            },
            getSiteId(){
                if(location.href.indexOf("?id") >= 0){
                    this.currentSiteId = parseInt(this.getUrlParameter('id', location.href));
                } else if (location.href.indexOf("?timeline") >= 0){
                    this.currentSiteTimelineState = parseInt(this.getUrlParameter('timeline', location.href));
                }
            },
            getFilterValue(item) {
                this.value = item;
                this.$emit('get-value', {'key': this.filterKey, 'value': this.value});

            },
            setPushState(item) {
                this.value = item;

                // Add clicked timeline_state to history
                if (history.pushState) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?timeline='+item;
                    window.history.pushState({path:newurl},'',newurl);
                }

            },
            getTimelineStateName(id) {
                let timelineStates = this.timelineStates;

                for (var i in timelineStates) {
                    if (timelineStates[i].id == id) {
                        return timelineStates[i].value;
                    }
                }
            },
            openAlertModal() {
                this.alertModalActive = true;
            },
            closeAlertModal() {
                this.alertModalActive = false;
            },
        }
    }
</script>
